import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'

type State = {} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.VERIFY_SET_MOBILE_ASYNC,
    Actions.VERIFY_SET_MOBILE_SUCCESS,
    Actions.VERIFY_SET_MOBILE_FAIL
  >,
): State => {
  switch (action.type) {
    case Actions.VERIFY_SET_MOBILE_ASYNC:
    case Actions.VERIFY_SET_MOBILE_SUCCESS:
    case Actions.VERIFY_SET_MOBILE_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    default:
      return state
  }
}
